import { render, staticRenderFns } from "./RightSidePanel.vue?vue&type=template&id=4dffae64&scoped=true&"
import script from "./RightSidePanel.vue?vue&type=script&lang=js&"
export * from "./RightSidePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dffae64",
  null
  
)

export default component.exports